/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionBudgetWidgetConfiguration extends models.BaseGroupByDataWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("DimensionBudgetWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return DimensionBudgetWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<DimensionBudgetWidgetConfiguration>): DimensionBudgetWidgetConfiguration {
        let obj = Object.assign(new DimensionBudgetWidgetConfiguration(), model);
        DimensionBudgetWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionBudgetWidgetConfiguration>): DimensionBudgetWidgetConfiguration {
        if (!model) return null;
        return DimensionBudgetWidgetConfiguration.newInstance(<DimensionBudgetWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionBudgetWidgetConfiguration) {
        if (!obj) return;

        models.DimensionBudgetWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionBudgetWidgetConfiguration): boolean {
        if (models.BaseGroupByDataWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DimensionBudgetWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
